// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBfxHfcf4wnHPmMr-Bom2vkOdDDJmaL0MI",
    authDomain: "portfolio-3cba0.firebaseapp.com",
    projectId: "portfolio-3cba0",
    storageBucket: "portfolio-3cba0.appspot.com",
    messagingSenderId: "837539712872",
    appId: "1:837539712872:web:4c7c60c68e9b52564110dd",
    measurementId: "G-4WBPH23QSZ"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
